// Gemeinsame Helfer für Avatar-Kreise (Initialen + stabile Farbe pro Person)

const AVATAR_COLORS = [
  "#3b6fd4", "#2f8f6b", "#b5562b", "#8a4fc4",
  "#c0396b", "#2d8a9a", "#7a6a1f", "#4b5a6b",
];

export function getInitials(nameOrEmail) {
  const s = String(nameOrEmail || "").trim();
  if (!s) return "?";
  const parts = s.split(/\s+/).filter(Boolean);
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

export function getAvatarColor(seed) {
  const s = String(seed ?? "");
  let hash = 0;
  for (let i = 0; i < s.length; i++) hash = (hash * 31 + s.charCodeAt(i)) >>> 0;
  return AVATAR_COLORS[hash % AVATAR_COLORS.length];
}
